import {
  IScenarioRunResponseDataModel,
  IScenarioWeightedRunResponseDataModel,
} from '../../data-models/scenario-run.data-model';
import { IScenarioDataModel } from '../../data-models/scenario.data-model';
import { MaggieHttp } from '../MaggieHttp';

export async function fetchScenariosForCompany(companyId: number) {
  const { data } = await MaggieHttp.maggie.get<IScenarioDataModel[]>(`/company/${companyId}/scenarios`);
  return data;
}

export async function createScenario(scenarioPayload: Partial<IScenarioDataModel>) {
  const { data } = await MaggieHttp.maggie.post<Partial<IScenarioDataModel>, IScenarioDataModel>(
    '/scenario',
    scenarioPayload
  );
  return data;
}

export async function updateScenario(scenarioId: number, scenarioPayload: Partial<IScenarioDataModel>) {
  const { data } = await MaggieHttp.maggie.put<Partial<IScenarioDataModel>, IScenarioDataModel>(
    `/scenario/${scenarioId}`,
    scenarioPayload
  );
  return data;
}

// Weight-only update: any user with company access may set the % Chance (the rest of the scenario stays owner-gated).
export async function updateScenarioWeight(scenarioId: number, probabilityWeight: number | null) {
  const { data } = await MaggieHttp.maggie.patch<{ probabilityWeight: number | null }, IScenarioDataModel>(
    `/scenario/${scenarioId}/weight`,
    { probabilityWeight }
  );
  return data;
}

export async function deleteScenario(scenarioId: number) {
  const { data } = await MaggieHttp.maggie.delete<IScenarioDataModel>(`scenario/${scenarioId}`);
  return data;
}

export async function runScenario(scenario: Partial<IScenarioDataModel>) {
  const { data } = await MaggieHttp.maggie.post<Partial<IScenarioDataModel>, IScenarioRunResponseDataModel>(
    `/scenario/run`,
    scenario
  );
  return data;
}

export async function runWeightedScenarios(companyId: number) {
  const { data } = await MaggieHttp.maggie.post<{ companyId: number }, IScenarioWeightedRunResponseDataModel>(
    `/scenario/weighted`,
    { companyId }
  );
  return data;
}
